import React, { useState } from 'react';
import { get as _get } from 'lodash-es';
import PopupBundler from '../popups/PopupBundler';
import CompatioAnalytics from '../../api/CompatioAnalytics';

const ProductAddToCart = ({
  _singleProduct,
  _variantId,
  _baseItemId,
  _userId,
  _singleProductName,
  _singleProductImage,
  _singleProductPrice,
  isReel,
  _singleProductCat,
  isreeladded,
  xrsuserid,
  reelid,
  additionaloptions,
  backingproduct,
  popCloseBox,
}) => {
  const [ShowOptions, SetShowOptions] = useState(false);

  const handleAddClick = singleProduct => {
    CompatioAnalytics.track(CompatioAnalytics.events.xrsAddToCartClick, {
      variant_id: singleProduct.merchantProductSku,
      product_name: singleProduct.productName,
      click_action: CompatioAnalytics.clicks.xrsAddToCart,
    });
  };

  //to be moved to HelperMethods.js
  const getDefaultBacking = () => {
    const backingdata = _get(
      window,
      'compatioConfig.compatibleProducts.backingData'
    );
    return backingdata[0] && backingdata[0].variantId;
  };
  const toggleBundler = () => {
    SetShowOptions(false);
  };

  return (
    <>
      <button
        type="button"
        value="Add to cart"
        id={`AddToCart-${_variantId}`}
        data-baseitemid={_baseItemId}
        data-userid={_userId}
        className="xrsbutton-collectionpop btn btn--full bundler-button btn btn--full add-to-cart"
        data-section-id={_variantId}
        data-product-handle={_singleProduct.productHandle}
        data-product-url={_singleProduct.url_product}
        data-product-name={_singleProductName}
        data-product-img={_singleProductImage}
        data-product-price={_singleProductPrice}
        data-product-category={_singleProductCat}
        isreeladded={isreeladded}
        xrsuserid={xrsuserid}
        reelid={reelid}
        additionaloptions={additionaloptions ? additionaloptions : ' '}
        backingproduct={backingproduct ? backingproduct : ' '}
        onClick={() => {
          setTimeout(function() {
            popCloseBox();
          }, 900);
          SetShowOptions(true);
          handleAddClick(_singleProduct);
          const el = document.getElementById('xrs-bundle');
          if (el != undefined) {
            el.click();
          }
        }}
      >
        <span data-add-to-cart-text="" data-default-text="Add to cart">
          Add to cart
        </span>
      </button>
      {isReel && ShowOptions ? (
        <PopupBundler
          isOpen={ShowOptions}
          bundlerType="xrsoptions"
          toggleBundler={toggleBundler}
          parentProduct={_singleProduct}
          parentProductSku={_singleProduct.merchantProductSku}
          bundledProduct={_singleProduct.merchantProductSku}
          defaultBacking={getDefaultBacking()}
        />
      ) : null}
    </>
  );
};

export default ProductAddToCart;
